module.exports = __webpack_public_path__ + "img/product-banner_5.7f939a2a.png";